<div class="bg-white container text-dark">
  <h2 class="header">Challenges Report</h2>
  <div class="row">
    <!-- Date Range -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker" required>
        <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
        <input matEndDate placeholder="End date" [(ngModel)]="endDate">
      </mat-date-range-input>
      <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- Centre Selection -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Centre</mat-label>
      <mat-select
        multiple
        [(ngModel)]="selectCenter"
        (selectionChange)="setSelectedCentreCode($event)">

        <!-- Read More display -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedCentres.length; else placeholderCentre">
            {{ selectedCentres[0]?.centreName }}
            <span
              *ngIf="selectedCentres.length > 1"
              class="read-more-text"
              matTooltip="{{ getSelectedCentreNames() }}">
              + {{ selectedCentres.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderCentre>
            Select Centre
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_CENTRES" (click)="toggleAllCentres(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let c of (centres$ | async)" [value]="c">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Hospital Selection -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Hospital</mat-label>
      <mat-select multiple [(ngModel)]="selectedHospital" (selectionChange)="searchHospital($event)">

        <!-- Read More display -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedHospitalsReal.length; else placeholderHospital">
            {{ selectedHospitalsReal[0] }}
            <span
              *ngIf="selectedHospitalsReal.length > 1"
              class="read-more-text"
              matTooltip="{{ getSelectedHospitalNames() }}">
              + {{ selectedHospitalsReal.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderHospital>
            Select Hospital
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_HOSPITALS" (click)="toggleAllHospitals(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let c of (hospital$ | async)" [value]="c.hospitalName">
          {{ c.hospitalName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Age Range -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Age Range</mat-label>
      <mat-select multiple [(ngModel)]="selectedAgeRange" (selectionChange)="getAgeRange($event)">

        <!-- Read More display -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedAgeRangesReal.length; else placeholderAge">
            {{ getAgeRangeLabel(selectedAgeRangesReal[0]) }}
            <span
              *ngIf="selectedAgeRangesReal.length > 1"
              class="read-more-text"
              matTooltip="{{ getSelectedAgeRangeLabels() }}">
              + {{ selectedAgeRangesReal.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderAge>
            Select Age Range
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_AGE_RANGES" (click)="toggleAllAgeRanges(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option value="1,2">1-2 years</mat-option>
        <mat-option value="2,4">2-4 years</mat-option>
        <mat-option value="4,8">4-8 years</mat-option>
        <mat-option value="8,14">8-14 years</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Gender Filter -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Gender</mat-label>
      <mat-select [(ngModel)]="selectedGender" (selectionChange)="getGender($event)">
        <mat-option value="All">All</mat-option>
        <mat-option value="Male">Male</mat-option>
        <mat-option value="Female">Female</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- State Selection -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select State</mat-label>
      <mat-select multiple (selectionChange)="getStates($event)" [(ngModel)]="selectedState">

        <!-- Read More display -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedStatesReal.length; else placeholderState">
            {{ selectedStatesReal[0] }}
            <span
              *ngIf="selectedStatesReal.length > 1"
              class="read-more-text"
              matTooltip="{{ getSelectedStateNames() }}">
              + {{ selectedStatesReal.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderState>
            Select State
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_STATES" (click)="toggleAllStates(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let state of mState" [value]="state.name">
          {{ state.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Challenges Faced -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Challenges Faced</mat-label>
      <mat-select multiple [(ngModel)]="SelectedChallenges" (selectionChange)="getSelectedChallenges($event)">

        <!-- Read More display -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedChallengesReal.length; else placeholderChallenges">
            {{ selectedChallengesReal[0] }}
            <span
              *ngIf="selectedChallengesReal.length > 1"
              class="read-more-text"
              matTooltip="{{ getSelectedChallengesNames() }}">
              + {{ selectedChallengesReal.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderChallenges>
            Select Challenges
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_CHALLENGES" (click)="toggleAllChallenges(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let challenges of (_challengesFaced$ | async)" [value]="challenges">
          {{ challenges }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Counsellor Name -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Counsellor Name</mat-label>
      <mat-select multiple [(ngModel)]="SelectCounselorName" (selectionChange)="getCounselorName($event)">

        <!-- Read More display -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedCounsellorsReal.length; else placeholderCounselor">
            {{ selectedCounsellorsReal[0] }}
            <span
              *ngIf="selectedCounsellorsReal.length > 1"
              class="read-more-text"
              matTooltip="{{ getSelectedCounselorNames() }}">
              + {{ selectedCounsellorsReal.length - 1 }} more
            </span>
          </ng-container>

          <ng-template #placeholderCounselor>
            Select Counsellor
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_COUNSELLORS" (click)="toggleAllCounsellors(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let name of counselorName" [value]="name">
          {{ name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Action Buttons -->
    <div class="col-md-4 mb-4 d-flex gap-4 justify-content-start">
      <button mat-mini-fab color="accent" (click)="searchData()"><mat-icon>search</mat-icon></button>
      <button mat-mini-fab color="accent" (click)="ClearAll()"><mat-icon>clear</mat-icon></button>
      <button mat-mini-fab color="accent" *ngIf="!externalUser" (click)="downloadExcel()"><mat-icon>download</mat-icon></button>
    </div>
  </div>
  <ckeditor [editor]="Editor" (change)="onEditorChange($event)"></ckeditor>
  </div>

    <div class=" mt-2">
      <div class="row" #content>

        <div class="d-flex justify-content-between bg-white ">
          <div></div>

          <img src="assets/logo.png" alt="logo" >

        </div>
        <h3>Bar Graph for Specific Concerns</h3>

        <div>
          <p *ngIf="selectedCentreCode">Selected Centre : {{ selectedCentreCode }}</p>
          <p *ngIf="selectedHospital">Selected Hospital: {{ selectedHospital }}</p>
          <p *ngIf="selectedGender">Selected Gender: {{ selectedGender }}</p>
          <p *ngIf="startDate">Start Date: {{ startDate |date:'dd/MM/yyyy' }}</p>
          <p *ngIf="endDate">End Date: {{ endDate |date:'dd/MM/yyyy' }}</p>
          <p *ngIf="selectedAgeRange">Age: {{ selectedAgeRange }} - {{selectedAgeRange}} </p>
          <div [innerHTML]="remarks"></div>
          <!-- Uncomment the line below if you have selectedAgeRange -->
          <!-- <p>Selected Age Range: {{ selectedAgeRange }}</p> -->
        </div>

        <div class="col-md-12">
          <div class="card">
            <div class="header">
              <h2>Challenges Chart</h2>
            </div>
            <div class="body"  *ngIf="mShowChallengesChart">
              <apx-chart   [series]="areaChartOptions.series!" [chart]="areaChartOptions.chart!" [plotOptions]="areaChartOptions.plotOptions!"
                         [xaxis]="areaChartOptions.xaxis!" [yaxis]="areaChartOptions.yaxis!" [colors]="areaChartOptions.colors!"
                         [stroke]="areaChartOptions.stroke!" [legend]="areaChartOptions.legend!" [grid]="areaChartOptions.grid!"
                         [tooltip]="areaChartOptions.tooltip!" [dataLabels]="areaChartOptions.dataLabels!"></apx-chart>
            </div>
          </div>
        </div>

        <div class="col-md-12" style="page-break-before: always">
          <div class="card">
            <div class="header">
              <h2 class="text-center">States Chart</h2>
            </div>
            <div class=""  *ngIf="mShowStatesChart" >
              <apx-chart style="height: 600px;" [series]="stateChartOptions.series!" [chart]="stateChartOptions.chart!"
                         [xaxis]="stateChartOptions.xaxis!" [yaxis]="stateChartOptions.yaxis!" [colors]="stateChartOptions.colors!"
                         [stroke]="stateChartOptions.stroke!" [legend]="stateChartOptions.legend!" [grid]="stateChartOptions.grid!"
                         [tooltip]="stateChartOptions.tooltip!" [dataLabels]="stateChartOptions.dataLabels!"></apx-chart>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card">
      <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
      </mat-form-field>
      <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="body">
        <!-- Define columns -->
        <ng-container matColumnDef="sr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr </th>
          <td mat-cell *matCellDef="let element;let i =index"> {{ i+1 }} </td>
        </ng-container>
        <ng-container matColumnDef="childName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </th>
          <td mat-cell *matCellDef="let element"> {{ element.childName }} </td>
        </ng-container>
        <ng-container matColumnDef="sessionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date</th>
          <td mat-cell *matCellDef="let element"> {{ (element.date)?.toDate() |date:'dd/MM/yyyy' }} </td>
        </ng-container>
        <ng-container matColumnDef="sessionType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type </th>
          <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="intervention">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Intervention </th>
          <td mat-cell *matCellDef="let element"> {{element.interventions}} </td>
        </ng-container>
        <ng-container matColumnDef="challenges">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges </th>
          <td mat-cell *matCellDef="let element"> {{element.challengesFaced}} </td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> State </th>
          <td mat-cell *matCellDef="let element"> {{element.state}} </td>
        </ng-container>
        <ng-container matColumnDef="centreName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name </th>
          <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
        </ng-container>
        <ng-container matColumnDef="submittedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Counsellor Name </th>
          <td mat-cell *matCellDef="let element"> {{element.submittedBy}} </td>
        </ng-container>
        <!-- Repeat for other columns -->

        <!-- Render rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <!-- No Data Message -->
      <ng-container *ngIf="dataSource.data.length === 0">
        <p class="no-data-message">No data matching the filter </p>
      </ng-container>
      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]" ></mat-paginator>

    </div>


